import React from "react"

import { Text, Box } from "@chakra-ui/react"

import BathRboIcon from "components/icons/rbo/bath_rbo_icon"
import BedRboIcon from "components/icons/rbo/bed_rbo_icon"
import GuestRboIcon from "components/icons/rbo/guest_rbo_icon"
import { PropertyDataNew } from "services/common"
import {
  FALLBACK_LOGO_IMAGE,
  IMAGE_POSTFIX_MOBILECARD,
} from "utils/global-constants"

import ImageWithFallback from "../../../../utilities/ImageWithFallback"

const PropertyFeature = ({
  icon,
  label,
  count,
}: {
  icon: React.ReactNode
  label: string
  count: number
}) => (
  <Text
    fontSize='14px'
    fontWeight={400}
    fontStyle='italic'
    lineHeight='17.07px'
    mb={{ base: 1.5, sm: "0px" }}
    color='#332F2F'
  >
    {icon} {count} {label}
    {count > 1 ? "s" : ""}
  </Text>
)

const PropertyDetails = ({
  property,
}: {
  property: PropertyDataNew | undefined
}) => {
  const propData = property?.propData
  const imageUploads = property?.propImages?.find((image) => !image.is_video)
  return (
    <>
      <ImageWithFallback
        src={
          imageUploads?.image_full_url
            ? `${imageUploads?.image_full_url}${IMAGE_POSTFIX_MOBILECARD}`
            : imageUploads?.file_url
        }
        alt={`propertyImage_${propData?.property_name || ""}`}
        fallbackSrc={FALLBACK_LOGO_IMAGE}
        height='185.98px'
        minHeight='185.98px'
        maxHeight='185.98px'
        width='100%'
        borderRadius='14px'
      />
      <Box flexGrow={1} textAlign='left' mt='4.81px'>
        <Text
          whiteSpace='break-spaces'
          color='#000'
          fontWeight={600}
          lineHeight='19.5px'
        >
          {propData?.property_name}
        </Text>
        <Text
          whiteSpace='break-spaces'
          lineHeight='19.5px'
          mt='7px'
          color='#000'
        >
          {[propData?.city, propData?.state].filter(Boolean).join(", ")}
        </Text>
      </Box>
      <Box display={{ sm: "flex" }} justifyContent='space-between' mt='13.58px'>
        <PropertyFeature
          icon={<BedRboIcon mr='4px' />}
          label='Bed'
          count={propData?.no_of_beds || 0}
        />
        <PropertyFeature
          icon={<BathRboIcon mr='4px' />}
          label='Bath'
          count={propData?.no_of_bathrooms || 0}
        />
        <PropertyFeature
          icon={<GuestRboIcon mr='4px' />}
          label='Max Guest'
          count={propData?.max_no_guests || 1}
        />
      </Box>
    </>
  )
}
export default PropertyDetails
